import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { INodeStatus } from '../top-bar-dto';
import { Subscription } from 'rxjs';
import { TooltipPosition } from '@angular/material/tooltip';
import { TopBarService } from '../top-bar.service';
import { isEmpty } from '@ubi-cell/core-utils';
import { UbiUiService } from 'libs/ui-componentes/src/lib/services/ubi-ui.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertBoxComponent } from 'libs/ui-componentes/src/lib/components/alert-box/alert-box.component';

@Component({
    selector: 'ubi-cell-top-bar-node-status',
    templateUrl: './top-bar-node-status.component.html',
    styleUrls: ['./top-bar-node-status.component.scss'],
    standalone: false
})
export class TopBarNodeStatusComponent implements OnInit, OnDestroy, OnChanges {
  @Input() mainScreen: string = '';
  @Input() subScreen: string = '';
  nodeStatus: INodeStatus;
  actionEvents: any = [];
  displayViewOption: any = [];
  nodeStatusSub$: Subscription;
  constructor(public _topBarConf: TopBarService,
    private _ubiUiService: UbiUiService,
    private dialog: MatDialog,
  ) {}
  selectedViewType = 'chart';
  matTooltipPosition: TooltipPosition = 'below';
  rangeBarJson = [];
  customPollutantKey: string = 'aqi';
  node = null;
  offlineNodes = 0;
  powerLossNodes = 0;
  lowRange = null;
  highRange = null;
  validPowerQualityScreens = ['power_quality_sustained', 'power_quality_momentary', 'power_quality_voltage'];

  ngOnInit(): void {
    this.loadCurrentConfig();
  }

  loadCurrentConfig(){
    this.nodeStatusSub$ = this._topBarConf?.currTopBarConfig?.subscribe(
      
      (status) => {        
        if (!isEmpty(status)) {
          if (this.mainScreen == 'aqi' && (this.subScreen == 'operational' || this.subScreen == 'maintenance')) {
            this.rangeBarJson  = []
            this.customPollutantKey = 'aqi'
            this.node = null;
            this.offlineNodes = 0;
            this.powerLossNodes = 0;
            this.highRange = null;
            this.lowRange = null;
            this.rangeBarJson = status['node_status']?.data?.rangeBarJson || [];
            this.customPollutantKey =
              status['node_status']?.data?.customPollutantKey || null;
            this.node = status['node_status']?.data?.node || null;
            this.offlineNodes =
              status['node_status']?.data?.offlineNodes || null;
            this.powerLossNodes =
              status['node_status']?.data?.powerLossNodes || null;
            this.highRange = status['node_status']?.data?.highRange || null;
            this.lowRange = status['node_status']?.data?.lowRange || null;
          }

          this.displayViewOption =
            status['node_status']?.display_view?.option || [];
          this.selectedViewType =
            status['node_status']?.display_view?.selected_view || 'chart';
          this.actionEvents = status['node_status']?.action_events || [];
          if (this.subScreen !== 'video_request')
            this.setNodeStatusForVideoRequest();
          this.nodeStatus = {
            info_message: status['node_status']?.info_message,
            label: status['node_status']?.label,
            label_mobile: status['node_status']?.label_mobile,
            legends: status['node_status']?.legends,
          };
        } else {
          this.nodeStatus = null;
        }
      }
    );
  }
  setNodeStatusForVideoRequest() {
    this._topBarConf.topBarConfigOpt.value[
      this.mainScreen
    ].video_request?.node_status?.action_events.forEach((element) => {
      element.controls.forEach((data) => {
        data.mode = 'disable';
        data.class = 'ub-button ub-button-primary';
        data.display = true;
      });
    });
  }

  ngOnChanges() {
    if (
      this.mainScreen === 'cameras_video' &&
      (this.subScreen == 'vehicle_count' ||
        this.subScreen == 'pedestrian_count' ||
        this.subScreen == 'bicycle_count')
    ) {
      if (this.selectedViewType == 'chart') {
        this._topBarConf?.currTopBarConfig.value['node_status'].legends.forEach(
          (legend) => {
            legend.display = false;
          }
        );
      }
    }

    if(this.mainScreen == 'aqi' && (this.subScreen == 'operational' || this.subScreen == 'maintenance')){
      this.loadCurrentConfig();
    }
  }

  onNodeStatusClick(value) {
    this._topBarConf?.addNodeStatusFilter?.next(value?.key);
  }

  switchDisplayView(view) {
    this.selectedViewType = view;
    this._topBarConf.topBarConfigOpt.value[this.mainScreen][
      this.subScreen
    ].node_status.display_view.selected_view = view;
    this._topBarConf.currTopBarConfig.next(
      this._topBarConf.topBarConfigOpt.value[this.mainScreen][this.subScreen]
    );
  }

  userClick(data) {
    this._topBarConf.currTopBarActionConfig.next(data);
  }

  selectionChange(data) {
    this._topBarConf.currTopBarDropDownSelectionChange.next(data);
  }

  isPowerQualityScreen(): boolean {
    return this.validPowerQualityScreens.includes(this.mainScreen);
  }

  ngOnDestroy(): void {
    this.rangeBarJson  = []
    this.customPollutantKey = 'aqi'
    this.node = null;
    this.offlineNodes = 0;
    this.powerLossNodes = 0;
    this.highRange = null;
    this.lowRange = null;
    // Set O for legends counts
    this._topBarConf.currTopBarConfig?.value?.node_status?.legends?.forEach(
      (element: any) => {
        if (element && element?.count) {
          element['count'] = 0;
        }
      }
    );

    this.nodeStatus = null;
    if (this.nodeStatusSub$) {
      this.nodeStatusSub$.unsubscribe();
    }
  }
}
